import script from "./Boletos_58.vue?vue&type=script&setup=true&lang=js"
export * from "./Boletos_58.vue?vue&type=script&setup=true&lang=js"

import "./Boletos_58.vue?vue&type=style&index=0&id=30d34492&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30d34492"]])

export default __exports__